// src/firebase/config.js
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyBfYVgLo2qLNZM0YGhWlbLg3zlG8FUpwYQ",
  authDomain: "dciwallet-92840.firebaseapp.com",
  projectId: "dciwallet-92840",
  storageBucket: "dciwallet-92840.firebasestorage.app",
  messagingSenderId: "943609109383",
  appId: "1:943609109383:web:284693f670cd082afa1122",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth
export const auth = getAuth(app);

// Initialize Google Auth Provider
export const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({
  prompt: 'select_account'
});

export default app;